import React from "react";

const Skills = props => {
  const { other, skillLogo } = styles;
  return (
    <div className="animated bounce" style={other}>
      <img style={skillLogo} src={require(`${props.image}`)} alt="skills" />
    </div>
  );
};

const styles = {
  skills: {
    width: "100%",
    margin: "1rem auto",
    display: "flex",
    flexFLow: "row wrap",
    flexWrap: "wrap"
  },
  other: {
    border: "2px solid white",
    margin: "1rem 1rem",
    borderRadius: "20%",
    backgroundColor: "white"
  },
  skillLogo: {
    height: "70",
    width: "70",
    borderRadius: "10%"
  }
};

export default Skills;
